export default {
  token: state => state.token
}
